import getColor from "@insite/mobius/utilities/getColor";
import { defaultBillingAddressStyles } from "@waytek/Overrides/Widgets/AccountSettings/DefaultBillingAddress";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

defaultBillingAddressStyles.headingGridItem = {
    ...defaultBillingAddressStyles.headingGridItem,

    css: css`
        border-bottom: 3px solid ${getColor("common.global.industrialTaupe")};
        margin-bottom: 20px;
    `,
};

defaultBillingAddressStyles.headingText = {
    ...defaultBillingAddressStyles.headingText,
    as: "h2",
    variant: "h6",
    css: css`
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.78;
        letter-spacing: normal;
        margin-bottom: 0;
    `,
};

defaultBillingAddressStyles.editLink = {
    ...defaultBillingAddressStyles.editLink,
    css: css`
        display: none;
    `,
};

defaultBillingAddressStyles.addressInfoDisplayGridItem = {
    ...defaultBillingAddressStyles.addressInfoDisplayGridItem,
    css: css`
        &&& {
            margin-top: 20px;
        }
    `,
};

defaultBillingAddressStyles.addressDisplay = {
    ...defaultBillingAddressStyles.addressDisplay,
    stateText: {
        css: css`
            display: none;
        `,
    },
    wrapper: {
        css: css`
            p {
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.71;
                letter-spacing: normal;
            }
        `,
    },
};
